import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        main: {
            w: '100%',
            backgroundColor: 'background.base.default',
        },
        container: {
            w: '100%',
            maxW: {xl: remCalc(1400), base: '100%'},
            mx: 'auto',
            mb: {base: remCalc(16), md: remCalc(24), lg: remCalc(40)},
            flexDirection: 'column',
            textAlign: 'center',
            justifyContent: 'center',
        },
        chevronIcon: {
            w: remCalc(36),
            h: remCalc(36),
            position: 'absolute',
            color: 'foreground.neutral.inverse',
            bg: 'background.base.overlay',
            boxShadow: 'borderShadow',
            backdropFilter: 'blur(5px)',
            border: 'small',
            borderColor: 'border.neutral.highlight',
            borderStyle: 'solid',
            borderRadius: 'full',
            top: {base: remCalc(166), md: remCalc(84), lg: remCalc(113), xl: remCalc(166)},
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            zIndex: '10',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            _after: {
                content: 'none',
                display: 'none',
            },
        },
        heading: {
            pt: {base: remCalc(16), md: remCalc(40)},
            pb: {base: remCalc(16), md: remCalc(24)},
            w: '100%',
            textStyle: 'head-large',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        bodycopy: {
            w: '100%',
            textStyle: 'body-large',
            fontWeight: 'normal',
            color: 'foreground.neutral.default',
            pb: {base: remCalc(16), md: remCalc(40)},
            sx: {
                p: {color: 'foreground.neutral.default'},
                strong: {color: 'foreground.neutral.default'},
                em: {color: 'foreground.neutral.default'},
                u: {color: 'foreground.neutral.default'},
                a: {
                    color: 'foreground.accent.default',
                    textDecoration: 'underline',
                },
            },
        },
        emptyTiles: {
            minH: {base: remCalc(332), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
        },
        noswipertiles: {
            mx: {base: remCalc(-8), lg: remCalc(-12)},
            pb: remCalc(24),
            overflow: 'hidden',
            whiteSpace: 'nowrap',
        },
        noswipertile: {
            px: {base: remCalc(8), lg: remCalc(12)},
            w: {base: '100%', md: '25%'},
            display: 'inline-block',
        },
        tile: {
            main: {
                gap: remCalc(24),
                flexDirection: 'column',
                justifyContent: 'flex-start',
                minH: '100%',
            },
            imagecontainer: {
                textAlign: 'center',
                borderRadius: 'large-1',
                overflow: 'hidden',
            },
            image: {
                w: '100%',
                m: 'auto',
                maxW: {base: remCalc(332), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
                minW: {base: remCalc(332), md: 'unset'},
                borderRadius: 'large-1',
                overflow: 'hidden',
                img: {
                    borderRadius: 'large-1',
                },
            },
            title: {
                textStyle: 'head-small',
                fontWeight: 'medium',
                color: 'foreground.neutral.default',
                whiteSpace: 'initial',
            },
            bodycopy: {
                textStyle: 'body-medium',
                fontWeight: 'normal',
                color: 'foreground.neutral.default',
                whiteSpace: 'initial',
                sx: {
                    p: {color: 'foreground.neutral.default'},
                    strong: {color: 'foreground.neutral.default'},
                    em: {color: 'foreground.neutral.default'},
                    u: {color: 'foreground.neutral.default'},
                    a: {
                        color: 'foreground.accent.default',
                        textDecoration: 'underline',
                    },
                },
            },
            features: {
                listStyleType: 'none',
            },
            feature: {
                py: remCalc(20),
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'foreground.neutral.default',
                whiteSpace: 'initial',
            },
            cta: {
                w: '100%',
                alignSelf: 'center',
                whiteSpace: 'unset',
                mt: 'auto',
            },
        },
        ctaContainer: {
            w: '100%',
            gap: {base: remCalc(16), md: remCalc(24)},
            flexDirection: {base: 'column', md: 'row'},
            justifyContent: {base: 'flex-start', md: 'center'},
            alignItems: {base: 'center', md: 'flex-start'},
        },
        ctas: {
            w: {base: remCalc(228), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
        },
    },
    variants: {
        recipesCarousel: {
            container: {
                maxW: '100%',
            },
            image: {
                w: '100%',
                m: 'auto',
                maxW: 'unset',
                minW: 'unset',
                borderRadius: 'large-1',
                img: {
                    borderRadius: 'large-1',
                },
            },
            tile: {
                gap: {
                    base: 'xsmall.base',
                    md: 'medium.base',
                },
                minH: 'unset',
                image: {
                    maxWidth: 'unset',
                    minWidth: 'unset',
                    borderRadius: 'large-1',
                    img: {
                        borderRadius: 'large-1',
                    },
                },
            },
        },
        black: {
            main: {
                backgroundColor: 'background.base.inverse',
                color: 'foreground.neutral.inverse',
            },
            heading: {
                color: 'foreground.neutral.inverse',
            },
            bodycopy: {
                color: 'foreground.neutral.inverse',
                sx: {
                    p: {color: 'foreground.neutral.inverse'},
                    strong: {color: 'foreground.neutral.inverse'},
                    em: {color: 'foreground.neutral.inverse'},
                    u: {color: 'foreground.neutral.inverse'},
                    a: {
                        color: 'foreground.accent.inverse',
                        textDecoration: 'underline',
                    },
                },
            },
            tile: {
                title: {
                    color: 'foreground.neutral.inverse',
                },
                bodycopy: {
                    color: 'foreground.neutral.inverse',
                    sx: {
                        p: {color: 'foreground.neutral.inverse'},
                        strong: {color: 'foreground.neutral.inverse'},
                        em: {color: 'foreground.neutral.inverse'},
                        u: {color: 'foreground.neutral.inverse'},
                        a: {
                            color: 'foreground.accent.inverse',
                            textDecoration: 'underline',
                        },
                    },
                },
                feature: {
                    color: 'foreground.neutral.inverse',
                },
            },
            chevronIcon: {},
        },
    },
}
